import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getWithAuth, postWithAuth } from "../../api/api";
import { API_URLS } from "../../api/apiConfig";

const ModalNewStarRezMap = ({ onClose }) => {
  const [showAlert, setIshowAlert] = useState(false);
  const [alertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRooms, setIsLoadingRooms] = useState(false);
  const [habitaciones, setHabitaciones] = useState([]);

  const [updateMap, setMap] = useState({
    starrez_number: "",
    starrez_name: "",
    room_id: "null",
    starrez_room_space: "",
    starrez_room_space_id: "",
  });

  useEffect(() => {
    const fetchAllRooms = async () => {
      setIsLoadingRooms(true);
      try {
        const data = await getWithAuth(API_URLS.GET_ALL_ROOMS);
        const habitacionesData = data.data.map((room) => ({
          id: room.id,
          title: `${room.number} ${room.name}`,
        }));
        setHabitaciones(habitacionesData);
      } catch (error) {
        setShowAlertMessage("Ha ocurrido un error conectando con el servidor");
        setIshowAlert(true);
        console.error("Error getting rooms:", error);
      } finally {
        setIsLoadingRooms(false);
      }
    };
    fetchAllRooms();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setMap((prevMap) => ({
      ...prevMap,
      [name]: type === "checkbox" ? !prevMap[name] : value,
    }));
  };

  const saveMap = async () => {
    try {
      setIsLoading(true);
      const response = await postWithAuth(
        API_URLS.NEW_STARREZ_MAPPING,
        updateMap,
      );
      if (response.message === "success") {
        setIsLoading(false);
        window.location.reload();
      } else if (response.message === "error") {
        setIsLoading(false);
        setIshowAlert(true);
        setShowAlertMessage(response.detail);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error creating StarRez mapping:", error);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    saveMap();
  };

  return (
    <Modal show={true} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Nuevo mapeo de habitación (StarRez)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form fv-plugins-bootstrap5 fv-plugins-framework">
          <div className="modal-body py-10 px-lg-17">
            <div className="scroll-y me-n7 pe-7">
              <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed mb-10 p-6">
                <i className="ki-outline ki-information fs-2tx text-warning me-4"></i>
                <div className="d-flex flex-stack flex-grow-1">
                  <div className="fw-semibold">
                    <h4 className="text-gray-900 fw-bold">Atención!</h4>
                    <div className="fs-6 text-gray-700">
                      Agregar o editar una habitación puede tener consecuencias
                      en tu inventario de disponibilidad
                    </div>
                  </div>
                </div>
              </div>
              {showAlert && (
                <div className="alert alert-danger d-flex align-items-center p-5">
                  <i className="fa-solid fa-triangle-exclamation fs-1 text-danger me-4"></i>
                  <div className="d-flex flex-column">
                    <span className="mb-1 text-danger">{alertMessage}</span>
                  </div>
                </div>
              )}
              {isLoadingRooms ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "10vh" }}
                >
                  <div
                    className="spinner-grow text-color-amarillo-livensa"
                    style={{ width: "5rem", height: "5em" }}
                    role="status"
                  ></div>
                </div>
              ) : (
                <>
                  <div className="row g-9 mb-8">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">
                        Número en StarRez
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="12"
                        name="starrez_number"
                        onChange={handleInputChange}
                        defaultValue=""
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="required fs-6 fw-semibold mb-2">
                        Nombre en StarRez
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Doble con vistas al mar y baño"
                        name="starrez_name"
                        onChange={handleInputChange}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="row g-9 mb-8">
                    <div className="d-flex flex-column mb-5 fv-row fv-plugins-icon-container">
                      <label className="form-label">Habitación</label>
                      <select
                        className="form-select"
                        onChange={handleInputChange}
                        name="room_id"
                        aria-label="Select example"
                      >
                        <option value="">Selecciona una habitación</option>
                        {habitaciones.map((room) => (
                          <option key={room.id} value={room.id}>
                            {room.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row g-9 mb-8">
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">
                        Room Space (StarRez)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Room Space"
                        name="starrez_room_space"
                        onChange={handleInputChange}
                        defaultValue=""
                      />
                    </div>
                    <div className="col-md-6 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2">
                        Room Space ID (StarRez)
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Room Space ID"
                        name="starrez_room_space_id"
                        onChange={handleInputChange}
                        defaultValue=""
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="modal-footer flex-center">
            <button
              type="reset"
              className="btn btn-light me-3"
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              type="submit"
              onClick={handleSave}
              className="btn btn-primary"
              data-kt-indicator={`${isLoading ? "on" : "off"}`}
            >
              <span className="indicator-label">Crear mapeo</span>
              <span className="indicator-progress">
                Guardando ...{" "}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ModalNewStarRezMap;
